import {
    CORE_LOAD_ALL_FLOOR_REQUEST,
    CORE_LOAD_ALL_FLOOR_SUCCESS,

    CORE_LOAD_ALL_AMENITIES_REQUEST,
    CORE_LOAD_ALL_AMENITIES_SUCCESS,

    CORE_LOAD_ROOMS_REQUEST,
    CORE_LOAD_ROOMS_SUCCESS,

    CORE_LOAD_ROOM_REQUEST,
    CORE_LOAD_ROOM_SUCCESS,

    CORE_LOAD_QRCODE_REQUEST,
    CORE_LOAD_QRCODE_SUCCESS,

    CORE_CHANGE_QRCODE_REQUEST,
    CORE_CHANGE_QRCODE_SUCCESS,

    CORE_CREATE_ROOM_REQUEST,
    CORE_CREATE_ROOM_SUCCESS,

    CORE_EDIT_ROOM_REQUEST,
    CORE_EDIT_ROOM_SUCCESS,

    CORE_DELETE_ROOM_REQUEST,
    CORE_DELETE_ROOM_SUCCESS,

    CORE_LOAD_DISABLE_ROOMS_REQUEST,
    CORE_LOAD_DISABLE_ROOMS_SUCCESS,

    CORE_LOAD_DISABLE_ROOM_REQUEST,
    CORE_LOAD_DISABLE_ROOM_SUCCESS,

    CORE_LOAD_ALL_ROOMTYPE_REQUEST,
    CORE_LOAD_ALL_ROOMTYPE_SUCCESS,

    CORE_FILTER_ROOM_REQUEST,
    CORE_FILTER_ROOM_SUCCESS,

    CORE_LOAD_PRIVATE_ROOM_REQUEST,
    CORE_LOAD_PRIVATE_ROOM_SUCCESS,

    CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST,
    CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS,

    CORE_LOAD_ROOMSFILTER_REQUEST,
    CORE_LOAD_ROOMSFILTER_SUCCESS,

} from '../../types'


const initialState = []
export default {
    floors: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_FLOOR_REQUEST:
                return initialState

            case CORE_LOAD_ALL_FLOOR_SUCCESS:
                if (action.payload[0]) {
                    let payload = action.payload
                    let floors = []
                    payload.forEach(data => {
                        floors.push({ key: data._id, text: data.name, value: data._id })
                    })
                    return floors
                }
                return action.payload
            default:
                return state
        }
    },
    amenities: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_AMENITIES_REQUEST:
                return initialState
            case CORE_LOAD_ALL_AMENITIES_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    room: (state = initialState, action) => {
        switch (action.type) {
            case CORE_CREATE_ROOM_REQUEST:
            case CORE_LOAD_ROOM_REQUEST:
            case CORE_EDIT_ROOM_REQUEST:
            case CORE_DELETE_ROOM_REQUEST:
            case CORE_LOAD_DISABLE_ROOM_REQUEST:
                return initialState
            case CORE_CREATE_ROOM_SUCCESS:
            case CORE_LOAD_ROOM_SUCCESS:
            case CORE_EDIT_ROOM_SUCCESS:
            case CORE_LOAD_DISABLE_ROOM_SUCCESS:
                return action.payload
            case CORE_DELETE_ROOM_SUCCESS:
                return {}

            default:
                return state
        }
    },
    rooms: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROOMS_REQUEST:
            case CORE_CHANGE_QRCODE_REQUEST:
            case CORE_FILTER_ROOM_REQUEST:
            case CORE_LOAD_ROOMSFILTER_REQUEST:
                return initialState
            case CORE_LOAD_ROOMS_SUCCESS:
            case CORE_CHANGE_QRCODE_SUCCESS:
            case CORE_FILTER_ROOM_SUCCESS:
            case CORE_LOAD_ROOMSFILTER_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    roomsByType: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST:
                return initialState
            case CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    disableRoom: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_DISABLE_ROOMS_REQUEST:
                return initialState
            case CORE_LOAD_DISABLE_ROOMS_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    qrcode: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_QRCODE_REQUEST:
          
                return initialState
            case CORE_LOAD_QRCODE_SUCCESS:
          
                return action.payload

            default:
                return state
        }
    },
    roomtype: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_ROOMTYPE_REQUEST:

                return initialState
            case CORE_LOAD_ALL_ROOMTYPE_SUCCESS:

                return action.payload

            default:
                return state
        }
    },
    private_rooms: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_PRIVATE_ROOM_REQUEST:
                return initialState
            case CORE_LOAD_PRIVATE_ROOM_SUCCESS:
                return action.payload

            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/features/rooms/reducer.js